<script>
import '@splidejs/vue-splide/css/skyblue';
import Toast from 'primevue/toast';

export default {
  components: {Toast},
  mounted() {},
  methods: {},
};
</script>

<template>
  <RouterView />
  <Toast
    ref="toast"
    :pt="{
      root: {
        style: {
          top: '90px',
        },
      },
    }">
    <template #message="slotProps">
      <div class="flex items-center gap-4" style="flex: 1">
        <i :class="slotProps.message.icon"></i>
        <div class="text-base font-base text-white">{{ slotProps.message.content }}</div>
      </div>
    </template>
  </Toast>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style>
@import '~normalize.css/normalize.css';
@import '~primevue/resources/themes/saga-blue/theme.css';
@import '~primevue/resources/primevue.min.css';
@import '~primeicons/primeicons.css';
@import '~vue-loaders/dist/vue-loaders.css';
</style>
